import {Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from "@angular/router";
import { RestUrlsConfig, EntityConfig, GenericConfig } from "@signature-it/ngx-generic/config";
import { PageNotificationService, SolrService, EventBusService } from "@signature-it/ngx-generic/services";
import {EventData, EventName} from "@signature-it/ngx-generic/classes";
import {SearchPageData, SolrOptionsEntityDTO} from '@signature-it/ngx-entity/models';
import {SolrEntityService} from "./solr-entity.service";
import {SolrTableService} from "@signature-it/ngx-generic/services";

declare let _: any;
@Injectable({
    providedIn: 'root'
})

export class SearchService {
    searchPageData = {};
    serviceType = {
    'entity': this.solrEntityService,
    'table': this.solrTableService,
    };

    public updateSearchPageData = new  BehaviorSubject(null);
    public searchPageDataLoading = new  BehaviorSubject<boolean>(false);
    subscriptionsList$: Array<Subscription> = [];

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService,
                protected activatedRoute: ActivatedRoute,
                public router:Router,
                protected solrEntityService: SolrEntityService,
                protected solrTableService: SolrTableService,
                protected solrService: SolrService,
                protected ngZone: NgZone,
                protected eventBusService: EventBusService,) {
        this.eventBusService.on(EventName.ENTITY_PAGE_QUERY_PARAMS_CHANGE, () => {
            Object.keys(this.searchPageData).forEach(key => {
                let parsedUrl = this.router.parseUrl(this.router.url);
                this.setData(parsedUrl, key);
                this.getItems(key);
            });
        })
    }

    isWaitingForDictionaryFacetResponse(key) {
        let searchPageData = this.searchPageData[key];
        return searchPageData.pageMode == 'dictionary' && !searchPageData.getActiveIndex() && ((!searchPageData.kw  && !searchPageData.activeFilters['entity_var_s'])|| searchPageData.searchLayoutMode == 'tab');

    }

    getSearchPageData(key, extraData = null): SearchPageData {
        if(!this.searchPageData[key]) {
            this.searchPageData[key] = this.createSearchPageData(key, extraData || {});
            let parsedUrl = this.router.parseUrl(this.router.url);
            this.setData(parsedUrl, key);
        } else if(extraData) {
           this.searchPageData[key] = Object.assign(this.searchPageData[key], EntityConfig.ngxSearch[key], extraData);
        }
        return this.searchPageData[key];
    }

    createSearchPageData(uri, extraData ={}) {
        return new SearchPageData({
            ...EntityConfig.ngxSearch[uri],
            ...extraData,
            'uri':  uri,
        });
    }

    setData(parsedUrl, key) {
        this.searchPageData[key].activeFilters = this.getActiveFilters(parsedUrl.queryParams, key);
        this.searchPageData[key].page = parsedUrl.queryParams['page'] || 1;
        this.searchPageData[key].itemsPerPage = Number.parseInt(parsedUrl.queryParams['itemsPerPage']) ||  this.searchPageData[key].itemsPerPageSelect[0] || GenericConfig.item_per_page[0];
        this.searchPageData[key].kw = parsedUrl.queryParams['kw'] ? new DOMParser().parseFromString(parsedUrl.queryParams['kw'], 'text/html').body.textContent : '';
        this.searchPageData[key].sort = parsedUrl.queryParams['sort'] || '';
        this.searchPageData[key].fragment = parsedUrl.fragment || '';
        if(EntityConfig.ngxSearch[key]?.parent && this.searchPageData[EntityConfig.ngxSearch[key].parent]){
            this.searchPageData[key].activeFilters = this.searchPageData[EntityConfig.ngxSearch[key].parent].activeFilters;
            this.searchPageData[key].filters = this.searchPageData[EntityConfig.ngxSearch[key].parent].filters;
        }
        this.updateSearchPageData.next(key);
    }

    getActiveFilters(queryParams, key) {
        let {page, itemsPerPage, kw, sort, edit, preview, ...updatedObject} = queryParams;
        if(this.searchPageData[key].limitParams && this.searchPageData[key].filters) {
            updatedObject=_.pickBy(updatedObject, (value, paramKey)=> {
                return this.searchPageData[key].filters.map(item => item['key']).includes(paramKey); } )
        }
        return updatedObject;
    }

    getItems(key, extraQryString = '', startDate = null, endDate = null) {
        if(this.isWaitingForDictionaryFacetResponse(key) && !extraQryString) return;
        const solrOptions = new SolrOptionsEntityDTO({
            sort: this.searchPageData[key].sort ||  (this.searchPageData[key].sortOptions[0]? this.searchPageData[key].sortOptions[0]['field']  : null),
            search: this.searchPageData[key].kw,
            itemsPerPage: this.searchPageData[key].itemsPerPage,
            pageNumber: this.searchPageData[key].page,
            filters: this.searchPageData[key].activeFilters,
            productType: this.searchPageData[key].productTypes,
            extraQryString: `${this.searchPageData[key].kw ? (this.searchPageData[key].solrQueryParamsSearch || this.searchPageData[key].solrQueryParams) : this.searchPageData[key].solrQueryParams}${extraQryString}`,
            stats: !!this.searchPageData[key].statsField,
            statsField: this.searchPageData[key].statsField
        });
        this.searchPageDataLoading.next(true);
        this.serviceType[this.searchPageData[key].solrTypeService].getSolr(solrOptions).subscribe(
            solrResponse => {
                this.searchPageData[key].items = solrResponse.response.docs;
                this.searchPageData[key].totalItems = solrResponse.response.numFound;
                this.searchPageData[key].facets = solrResponse.facets;
                this.searchPageData[key].spellcheck = solrResponse.spellcheck;
                this.eventBusService.emit(new EventData(`${EventName.ENTITY_GET_ITEMS_RESPONSE}`, {'key': key}));
                this.searchPageData[key].stats = solrResponse.stats?.stats_fields[this.searchPageData[key].statsField] ?? {};
                if(this.searchPageData[key].isFocusedFirst) {
                    let firstItem =  this.searchPageData[key].items && this.searchPageData[key].items[0];
                    if(firstItem) {
                        this.searchPageData[key].setFocusedElement(firstItem['doc_id_s'], true);
                    }
                }
                this.searchPageDataLoading.next(false);
                if(this.searchPageData[key].fragment) {
                    this.ngZone.runOutsideAngular(() => {
                            setTimeout(() => {
                                let el = document.getElementById(this.searchPageData[key].fragment);
                                if(el) {
                                    el.scrollIntoView(true);
                                    let scrolledY = window.scrollY;
                                    if(scrolledY){
                                        window.scroll(0, scrolledY - 100);
                                    }
                                }
                            }, 100);
                    })
                }
            }
        );
    }

    clickedSearchPageFilter(filters, key){
        if(!_.isEmpty(filters)) {
            let params = this.getParams(key, filters);
            this.router.navigate([], { queryParams: params});
        }
    }

    changeUrlParams(params, key, fragment = null) {
        this.router.navigate([], { queryParams: params, ...this.searchPageData[key].scroll && {fragment:  fragment}});
    }

    addUrlParam(params, key, fragment = null){
        let scrollTop = params['page'] &&  params['page'] != this.searchPageData[key].page || false;
        params = this.removeDefaultParams(params);
        params = this.provideCombineParams(params, key);
        const searchItemsGrid = this.searchPageData[key].searchItemsGrid;
        this.router.navigate([], {queryParams: params, ...this.searchPageData[key].scroll && {fragment:  fragment}, queryParamsHandling: "merge"}).then(res => {
            if(searchItemsGrid && searchItemsGrid['scrollToAfterPagination']){
                const element = document.getElementById(searchItemsGrid['scrollToAfterPagination']);
                element.scrollIntoView();
            } else if(scrollTop) {
                window.scroll(0, 0);
            }
        });
    }

    provideCombineParams(params, key) {

        //provide  dictionary on searchLayoutMode = "all" mode combine between dictionarySolrKey and kw or entity_var_s
        if(params[this.searchPageData[key].dictionarySolrKey] && this.searchPageData[key].searchLayoutMode == 'all') {
            params =  {...params, kw: null, entity_var_s: null}
        } else if(params['kw']){
            params[this.searchPageData[key].dictionarySolrKey] = null;
        }
        //provide  filter-tab and kw or entity_var_s
        if(params['kw']){
            params[this.searchPageData[key].filterTabSolrKey] = null;
        }
        //provide combine  entity_var_s and kw
        if(params['kw'] ) {
            params = {...params, entity_var_s: null}
        } else if(params['entity_var_s']){
            params = {...params, kw: null}
        }
        return params;
    }

    removeDefaultParams(params) {
        if(params['page'] == 1) {
            params['page'] = null;
        }
        if(params['itemsPerPage'] == GenericConfig.item_per_page[0]) {
            params['itemsPerPage'] = null;
        }
        if(params['kw'] == '') {
            params['kw'] = null;
        }
        return params;
    }

    getParams(key, filters?, kw?) {
        let params = {};
        if(filters) {
            if(filters.hasOwnProperty('fields')) {
                params = _.assign(params, filters.fields);
            }
        }
        params['page'] = 1;
        params['itemsPerPage'] = this.searchPageData[key].itemsPerPage;
        params['kw'] = kw || this.searchPageData[key].kw;
        return this.removeDefaultParams(params);
    }

    deleteData(key) {
        delete this.searchPageData[key];
    }

  
}
